module.exports = __webpack_public_path__ + "img/add_logo_full.4dca6746.png";